/* eslint-disable class-methods-use-this */
import React from 'react';
import PropTypes from 'prop-types';
import BaseClass from 'components/BaseClass';
import { wrapComponent } from 'utils/framework';
import store from 'store/Store';
import ChatLink from 'components/SmartChat/ChatLink/ChatLink';
import ChatButton from 'components/GladChat/ChatButton/ChatButton';
import SmartChat from 'components/SmartChat';
import GladChat from 'components/GladChat';
import { TestTargetReady } from 'constants/events';
import localeUtils from 'utils/LanguageLocale';
import { CHAT_ENTRY } from 'constants/chat';

class ChatEntry extends BaseClass {
    state = {
        abTestForGladChat: undefined
    };

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        Sephora.Util.onLastLoadEvent(window, [TestTargetReady], () => {
            store.setAndWatch('testTarget', this, newOffers => {
                const abTestForGladChat = newOffers.testTarget.offers?.customerServiceChatExpDisplay?.show;
                this.setState({
                    abTestForGladChat
                });
            });
        });
    }

    handleFlag = () => {
        const { isChatEnabled, enableSmartChat } = Sephora.configurationSettings;
        const { abTestForGladChat } = this.state;

        if (abTestForGladChat === undefined) {
            if (isChatEnabled && enableSmartChat) {
                return { isChatEnabled: false, enableSmartChat: true };
            }

            return { isChatEnabled, enableSmartChat };
        } else {
            return { isChatEnabled: abTestForGladChat && isChatEnabled, enableSmartChat: !abTestForGladChat && enableSmartChat };
        }
    };

    render() {
        const { type, showChat, ctaText } = this.props;
        const { isChatEnabled, enableSmartChat } = this.handleFlag();
        const isFrench = localeUtils.isFrench();

        if (type === CHAT_ENTRY.global) {
            return (
                <>
                    {enableSmartChat && SmartChat !== null && <SmartChat />}
                    {isChatEnabled && !isFrench && GladChat !== null && <GladChat />}
                </>
            );
        } else if (type === CHAT_ENTRY.customerService) {
            return (
                <>
                    {enableSmartChat && <ChatLink variant='button-transparent' />}
                    {isChatEnabled && (
                        <ChatButton
                            variant='help'
                            clickPage={type}
                        />
                    )}
                </>
            );
        } else if (type === CHAT_ENTRY.footer) {
            return (
                <>
                    {isChatEnabled && <ChatButton clickPage={type} />}
                    {enableSmartChat && showChat && <ChatLink variant='link' />}
                </>
            );
        } else if (type === CHAT_ENTRY.bccPlaceHolderApp) {
            return (
                <>
                    {isChatEnabled && <ChatButton variant='help' />}
                    {enableSmartChat && <ChatLink variant='button' />}
                </>
            );
        } else if (type === CHAT_ENTRY.fraudErrCheckout) {
            return (
                <>
                    {isChatEnabled && <ChatButton variant='help' />}
                    {enableSmartChat && (
                        <ChatLink
                            variant='link'
                            ctaText={ctaText}
                        />
                    )}
                </>
            );
        }

        return null;
    }
}

ChatEntry.propTypes = {
    type: PropTypes.oneOf(['global', 'customerService', 'footer', 'fraudErrCheckout', 'customerServiceChatApp']).isRequired,
    showChat: PropTypes.bool,
    ctaText: PropTypes.string
};

export default wrapComponent(ChatEntry, 'ChatEntry', true);
